import { makeStyles, Theme } from '@material-ui/core';

export const usePageNotFoundStyles = makeStyles<Theme>(theme => ({
  root: {
    padding: '20vh 0',
    height: 'calc(100vh - 240px)',
  },

  title: {
    marginBottom: theme.spacing(6),
    fontSize: 60,

    [theme.breakpoints.up('md')]: {
      fontSize: 80,
    },
  },

  button: {
    minWidth: 180,
  },
}));
